<div
  class="flex max-h-[90vh] flex-col overflow-hidden rounded-2xl bg-card shadow-xl dark:bg-zinc-900"
  [overlayLoader]="loading()">
  <div
    class="dialog-header sticky top-0 z-10 shrink-0 !m-0 !px-6 !py-4 bg-primary text-white shadow-sm flex items-start justify-between gap-3">
    <div class="flex items-center gap-3 min-w-0">
      <div class="w-11 h-11 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
        <mat-icon class="icon-size-6 !text-white" [svgIcon]="'heroicons_outline:document-text'"></mat-icon>
      </div>
      <div class="dialog-title min-w-0">
        <h2 class="!text-white !m-0 text-lg font-bold tracking-tight truncate">{{ title() }}</h2>
        <p class="dialog-subtitle !text-white/80 !m-0 text-sm mt-0.5">BizCare premium invoice</p>
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      class="!text-white hover:!bg-white/10 shrink-0"
      aria-label="Close"
      (click)="close()">
      <mat-icon class="!text-white" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
    </button>
  </div>

  <mat-dialog-content class="!m-0 min-h-0 flex-1 overflow-y-auto !px-6 !py-5 min-w-0">
    @if (error()) {
      <div
        class="flex items-start gap-3 rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700 dark:border-rose-900/50 dark:bg-rose-950/40 dark:text-rose-200">
        <mat-icon class="icon-size-5 shrink-0" [svgIcon]="'heroicons_outline:exclamation-circle'"></mat-icon>
        <span>{{ error() }}</span>
      </div>
    } @else if (pdfViewerUrl()) {
      <iframe
        class="scb-tenant-pdf-iframe"
        [src]="pdfViewerUrl()!"
        type="application/pdf"
        title="Invoice PDF"></iframe>
    } @else if (!loading()) {
      <div class="py-16 text-center text-sm text-secondary">No invoice PDF to display.</div>
    } @else {
      <div class="py-16 text-center text-sm text-secondary">Preparing invoice PDF…</div>
    }
  </mat-dialog-content>

  <div class="sticky bottom-0 z-10 shrink-0 bg-card px-6 pb-5 pt-2 dark:bg-zinc-900">
    <mat-dialog-actions align="end" class="!m-0 !p-0 min-h-0 gap-2">
      <button mat-stroked-button type="button" (click)="close()">Close</button>
      <button
        mat-flat-button
        color="primary"
        type="button"
        [disabled]="!pdfViewerUrl()"
        (click)="download()">
        <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
        <span class="ms-2">Download PDF</span>
      </button>
    </mat-dialog-actions>
  </div>
</div>
